import {QuestionsDataFetchedAction} from "@/models/scope/productSheet/questions/QuestionsDataFetchedAction";
import {ThunkResult} from "@/models/common/core/ThunkResult";
import {askQuestionService, getQuestions} from "@/services/productServices";
import {QUESTIONS_DATA_FETCHED, QUESTIONS_DATA_SEND} from "@/redux/reducers/responsive/actionsTypes";
import {AskQuestionAction} from "@/models/scope/productSheet/questions/AskQuestionAction";
import {Question} from "@/models/scope/productSheet/questions/Question";

export const loadQuestions = (data: {
    productId: string,
    pageIndex: number,
    reviewQuestionsItems: Question[]
}): ThunkResult<QuestionsDataFetchedAction> => (dispatch) => {
    let url = '/Catalog/Products/' + data.productId + '/Questions?PageIndex=' + data.pageIndex;
    getQuestions(url)
        .then(response => {
            dispatch({
                type: QUESTIONS_DATA_FETCHED,
                payload: {
                    summary: response.data.summary,
                    items: response.data.items,
                    reviewQuestionsItems: data.reviewQuestionsItems,
                    changeQuestionsFromClient: true,
                }
            })
        })
        .catch((error) => {
            console.log(error);
        })
}
export const askQuestion = (data: {
    email: string,
    content: string,
    pseudo: string,
    productId: string
}): ThunkResult<AskQuestionAction> => (dispatch) => {
    let url = '/Catalog/Products/' + data.productId + '/Questions/Question';
    askQuestionService(url, {
        "email": data.email,
        "content": data.content,
        "pseudo": data.pseudo
    })
        .then(response => {
            dispatch({
                type: QUESTIONS_DATA_SEND,
                payload: {
                    success: response.data.success,
                    message: response.data.message,
                }
            })
        })
        .catch((error) => {
            //TODO SES thow exception
            if (error.response) {

                dispatch({
                    type: QUESTIONS_DATA_SEND,
                    payload: {
                        success: false,
                        message: "error",
                    }
                });

            }

        })

}
